// extracted by mini-css-extract-plugin
export default {"container":"eIGQByxfGeptpmYgqKZt","position":"CEtUGDZUPQrn7zRQLHW3","badge":"Sxq73iT006qXVZSkhO4k","withIcon":"RcQ8aGerEqW1Pj4DsftS","pulse":"cUSDodvSbKqpTpWpIZjx"};